<template>
  <v-content fill-height class="about page">
    <v-container class="mt-4">
      <v-layout row wrap>
        <v-flex xs12 sm12 md3>
          <img src="../assets/wicak.jpg" height="200" width="200" class="circle profile">
        </v-flex>
        <v-flex xs12 sm12 md9>
          <h1>About Me</h1>
          <p class="text-xs-justify">Hello, my name is
            <span class="red--text">I Gede Wicaksana</span> you can call me <span class="red--text">Wicak</span>. I'm a Developer (specialist to web development), Programmer, and Entrepreneur. In this site, i will show you my gallery and another about me. I am a graduate of Computer Science, major in Software Engineering.
          </p>
          <p class="text-xs-justify">I Started my serious career as web developer and programmer by learned HTML + CSS + JavaScript Programming Languange (included Nodejs). I took a bootcamp on fullstack developer, online courses, and online programming challange. I have been passionate about programming.</p>
          <p class="text-xs-justify">I hope you can enjoy when exploring my gallery. If you have any problems, please contact me at <router-link to="/contact">contact me</router-link> page.</p>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 align-center v-for="job in jobs" :key="job.title">
          <v-card class="grey lighten-4 mx-2">
            <h1 class="text-xs-center">{{job.title}}</h1>
            <v-card-text class="text-xs-justify">{{job.description}}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      jobs: [
        {
          title: "Indodax",
          description:
            "Indodax was a digital asset marketplace company. In this company, i learned a lot about blokchain, smart contract, and all about cryptocurrency while doing my job as customer support. As i learned, i think blockchain is new erra, which is that can save and distribute a lot of data. "
        },
        {
          title: "Software Engineer in Refactory",
          description:
            "Working in Refactory, i and team have been building microservice system using Go Programming Languange from scratch. My role is as BackEnd programmer. I handle few service, and make between service can comunicate. I learn a lot about microservice arcithecture, such as how to use gRPC, api gateway, and much-much more."
        },
        {
          title: "Freelancer",
          description:
            "As a freelancer, i have some job in building a website. Some project i have been finishing like a simple portfolio website, online store (backend), and other. I learn a lot when i work as freelancer, such as time management and how to serve client."
        }
      ]
    };
  }
};
</script>

<style>
</style>
